module.exports = __webpack_public_path__ + "static/media/JumaGadach.27e3df29.png";